export const SUBSCRIBE_TIME_TYPE_OPTIONS = [
  { key: 4, label: '单次' },
  { key: 1, label: '每天' },
  { key: 2, label: '每周' },
  { key: 3, label: '每月' }
]

export const SUBSCRIBE_WEEK_OPTIONS = [
  { key: 1, label: '周一' },
  { key: 2, label: '周二' },
  { key: 3, label: '周三' },
  { key: 4, label: '周四' },
  { key: 5, label: '周五' },
  { key: 6, label: '周六' },
  { key: 7, label: '周日' }
]

// 每月可选 1-31 号
export const SUBSCRIBE_MONTH_OPTIONS = Array.from({ length: 31 }, (_, index) => index + 1)

// week / monthDay 为数组，按升序展示
export const sortAsc = (list) => [...list].sort((a, b) => a - b)

// 列表与详情返回扁平字段：timeType（1 每天 / 2 每周 / 3 每月 / 4 单次）、time（HH:mm）、
// week（1-7 的数组）、monthDay（1-31 的数组）、date（单次的 YYYY-MM-DD）
export const formatTriggerText = (item = {}) => {
  const { timeType, time, week, monthDay, date } = item
  const timeTypeLabel = SUBSCRIBE_TIME_TYPE_OPTIONS.find((option) => option.key === timeType)?.label
  if (!timeTypeLabel || !time) return '--'

  if (timeType === 2) {
    const weekLabels = sortAsc(week).map(
      (item) => SUBSCRIBE_WEEK_OPTIONS.find((option) => option.key === item).label
    )
    return weekLabels.length
      ? `每周${weekLabels.map((label) => label.slice(1)).join('、')} ${time}`
      : '--'
  }
  if (timeType === 3) {
    const monthDays = sortAsc(monthDay)
    return monthDays.length ? `每月 ${monthDays.join('、')} 号 ${time}` : '--'
  }
  if (timeType === 4) return date ? `${timeTypeLabel} ${date} ${time}` : `${timeTypeLabel} ${time}`

  return `${timeTypeLabel} ${time}`
}

// 回填编辑弹窗。执行时间只支持「每天 / 每周 / 每月 / 单次」，消息推送的 targetType 只支持 1 单聊 / 2 群聊，
export const parseDetailToForm = (item = {}) => {
  const { timeType, time, week, monthDay, date, targetType, channelEnabled, channelId } = item

  return {
    timeType: SUBSCRIBE_TIME_TYPE_OPTIONS.some((option) => option.key === timeType) ? timeType : 1,
    // 后端只在 timeType 为 2/3 时才返回这两个字段，其他类型没有，需兜回空数组避免表单里出现 undefined
    week: week ?? [],
    monthDay: monthDay ?? [],
    date: date || '',
    time: time || '09:00',
    // targetType 取值与 CHANNEL_TAB_OPTIONS 的 value 一致（见 channels.js），决定渲染哪个渠道选择器
    targetType: [1, 2].includes(targetType) ? targetType : 1,
    channelEnabled: channelEnabled ?? false,
    // 后端只返回一个 channelId，按 targetType 回填到对应类型的选择器字段
    privateChannelId: targetType === 1 ? (channelId ?? '') : '',
    groupChannelId: targetType === 2 ? (channelId ?? '') : ''
  }
}
